/**************************************************
 * Nombre:       Home_Experiencia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import envio from '../../../Recursos/ic_envio.svg'
import cambia from '../../../Recursos/ic_cambia.svg'
import consutla from '../../../Recursos/ic_consulta.svg'
import asesorate from '../../../Recursos/ic_asesorarte.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Experiencia = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontWeight: 600,
                                fontSize: sCell ? 32 : 54,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>Una experiencia de compra
                                única</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 10}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 8}}
                                spacing={4}
                            >


                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs:6, sm: 6, md: 6}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <img src={envio} width={90} height={'auto'}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20, fontWeight: 400, textAlign: 'center'}}>Recibe
                                            <span style={{fontWeight: 600, marginLeft: 5, marginRight: 5}}>
                                                     envío GRATIS
                                                </span>
                                            comprando $80.000 o más.</Typography>
                                    </Grid>

                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 6, sm: 6, md: 6}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <img src={cambia} width={90} height={'auto'}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20, fontWeight: 400, textAlign: 'center'}}>
                                            <span style={{fontWeight: 600, marginLeft: 0, marginRight: 5}}>
                                                    Cambia o devuelve
                                                </span>
                                            <br/>
                                            sin complicación</Typography>
                                    </Grid>

                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 6, sm: 6, md: 6}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <img src={consutla} width={90} height={'auto'}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20, fontWeight: 400, textAlign: 'center'}}>Consulta
                                            fácil el <br/>
                                            <span style={{fontWeight: 600, marginLeft: 5, marginRight: 5}}>
                                                     estado de tu orden
                                                </span>
                                        </Typography>
                                    </Grid>

                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 6, sm: 6, md: 6}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <img src={asesorate} width={90} height={'auto'}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20, fontWeight: 400, textAlign: 'center'}}>Déjanos
                                            <br/>
                                            <span style={{fontWeight: 600, marginLeft: 5, marginRight: 5}}>
                                                   asesorarte
                                                </span>
                                        </Typography>
                                    </Grid>

                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Experiencia

